import { useMemo } from 'react';
import { useOrgTier } from 'new/hooks/adapters/useOrgTier';
import { useFeatureFlag } from 'new/hooks/useFeatureFlags';

export function useRestrictedTiers() {
  const orgTier = useOrgTier();
  const restrictedTiers = useFeatureFlag('UI_LIMITED_ACCESS') as any;

  return useMemo(() => {
    const orgId = orgTier?.id;
    const hasExpressTierLimitedAccess = restrictedTiers?.express_tiers?.includes(orgId) ?? false;
    const hasSelfSignupTierLimitedAccess =
      restrictedTiers?.self_signup_tiers?.includes(orgId) ?? false;

    return {
      hasExpressTierLimitedAccess,
      hasSelfSignupTierLimitedAccess,
      restrictedTiers,
    };
  }, [restrictedTiers, orgTier]);
}
